<template>
	<div class="banner2">
		<div :class="'logoTest ' + aniClass">
			<img :class="'imgl ' + aniIconClass" src="../../assets/logo/lw.png">
			<!-- <img v-else class="imgTop" src="../../assets/logo/lw.png"> -->
			<img :class="'imgr ' + aniIconClassRight" src="../../assets/logo/rw.png" >
			Gamehaus<i class="iconText"></i>
		</div>
		<div :class="$i18n.locale == 'cn' ? 'banner2containtTextcn' : 'banner2containtText'">
			
			{{$t('banner2.indroduce')}}
		</div>
		<slider v-model="sliderIndex" :touch="true" :interval="2500" :speed="1000" :autoplay="true" :control-btn="false" animation="normal"
			class="bannerSwiper" style="width: 90vw; height: 30vh;">
			<slider-item class="slideritem" style="">
				<p class="slideritemText slideritemLeft">
					{{$t('banner2.title1')}}
				</p>
			</slider-item>
			<slider-item class="slideritem">
				<p class="slideritemText slideritemLeft">
					{{$t('banner2.title2')}}
				</p> 
			</slider-item>
			<slider-item class="slideritem">
				<p class="slideritemText slideritemLeft">
					{{$t('banner2.title3')}}
				</p>
			</slider-item>
		</slider>
	</div>
</template>

<script>
	import {
		SlideContainer,
		SlidePage
	} from 'vue-slidepage'
	import {
		Slider,
		SliderItem
	} from 'vue-easy-slider'
	export default {
		props: ['curpage', 'aniDownUp'],
		components: {
			Slider,
			SliderItem
		},
		data() {
			return {
				sliderIndex: 0,
				aniClass: '', // 默认为空
				aniIconClass: '', // 左边的动画logoLeftAni
				aniIconClassRight: ''
			}
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					if (newvalue === 2) {
						this.sliderIndex = 0
						this.aniIconClass = ''
						if (this.aniDownUp == 'down') {
							this.aniClass = 'logoTestDown'
							this.aniIconClass = 'logoANileft'
							this.aniIconClassRight = 'logoANiright'
						}
					} else { // 不在是当前页面了
						this.aniClass =''
						if (this.aniDownUp == 'down') { // 跳转到下一页
							this.aniIconClass = 'logoLeftAni'
						} else {
							this.aniIconClass = ''
							this.aniIconClassRight = ''
						}
					}
				},
				immediate: true
			},
			'aniDownUp': {
				handler(newvalue, oldvalue) {
					// console.log(newvalue, 'newvalue')
				},
				immediate: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .slider-btn {
		display: none !important;
	}
	/deep/ .slider-indicator-icon {
		background-color: rgba(0, 0, 0, 0) !important;
		margin: 1px 0.1rem !important;
		border: 1px solid #fff !important;
		width: 10px !important;
		height: 10px !important;
	}
	/deep/ .slider-indicator-active {
		background-color: #fff !important;
	}
	.banner2 {
		height: 100vh;
		// background-image: url('../../assets/bg.jpg');
		background-repeat:no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		padding: 2.575rem 1.25rem;
		padding-left: 1.5625rem;
		// height: 100vh;
		background-color: #808080;
		position: relative;
		.logoTest {
			display: inline-block;
			position: absolute;
			// opacity: 0;
			font-size: 1rem;
			color: #fff;
			top: 40%;
			transform: translateY(-50%);
			z-index: 999;
			img {
				position: absolute;
				// width: 0.5rem;
				width: 2.4rem;
				top: -0.5rem;
			}
			.imgl {
				left: 0;
				width: 0.5rem;
				// z-index: 999;
				// animation-iteration-count:infinite;
			}
			.imgr {
				right: 0.2rem;
				width: 0.5rem;
				// left: 101%;;
			}
			.iconText {
				font-size:0.25rem;
				vertical-align: super;
				font-style: normal;
			}
		}
		.logoTestDown {
			top: 0;
			opacity: 0;
			transform: translateY(-50%);
			animation: logoDownAmi 0.5s;
			animation-fill-mode:forwards;
			animation-delay: 0.5s;
			animation-timing-function:ease-in;
			img {
				position: absolute;
				width: 0.5rem;
				top: -0.5rem;
			}
			.imgl {
				left: 0;
				// width: 0.5rem;
				// z-index: 999;
				// animation-iteration-count:infinite;
			}
			.imgr {
				// right: 0.2rem;
				right: 0.2rem;
			}
			.iconText {
				font-size:0.25rem;
				vertical-align: super;
				font-style: normal;
			}
		}
		// .logoANileft {
		// 	animation: logoleftAmi 0.5s;
		// 	animation-fill-mode:forwards;
		// 	animation-delay: 2s;
		// 	animation-timing-function:ease-in;
		// }
		// .logoANiright {
		// 	animation: rightleftAmi 0.5s;
		// 	animation-fill-mode:forwards;
		// 	animation-delay: 2s;
		// 	animation-timing-function:ease-in;
		// }
		.banner2containtText {
			position: absolute;
			top: 40%;
			transform: translateY(-50%);
			box-sizing: border-box;
			padding-top: 1.07rem;
			font-size: 0.675rem;
			color: #fff;
			text-indent:8em;
			height: 3rem;
			line-height: 1.1rem;
		}
		.banner2containtTextcn {
			position: absolute;
			// background-color: red;
			top: 40%;
			transform: translateY(-50%);
			box-sizing: border-box;
			padding-top: 1.07rem;
			font-size: 0.675rem;
			
			color: #fff;
			text-indent:8em;
			height: 3rem;
			line-height: 1.1rem;
		}
		.bannerSwiper {
			position: absolute;
			// top: 0;
			// height: 100vh;
			display: flex;
			bottom: 0.625rem;
			.slideritem {
				// display: flex;
				width: 100%;
				height: 100%;
				// background-color: aqua;
				box-sizing: border-box;
				word-break:keep-all;     /* 不换行 */
				white-space:nowrap;      /* 不换行 */
				overflow: hidden;         /* 内容超出宽度时隐藏超出部分的内容 */
				// padding-left: 1.5rem;
				.slideritemText {
					-webkit-text-stroke: 1px #fff;
					-webkit-text-fill-color : transparent;
					font-family: 'PilatTest-Bold';
					// src: url("/assets/PilatTest-Bold.otf") format("otf");
					font-size: 2.05rem;
					font-weight: 700;
					// margin-top: 1.5rem;
					
				}
				.slideritemLeft {
					width: 80%;
					// margin-right: 400px;
				}
				.slideritemRight {
					text-align: right;
					margin-left: 10%;
				}
			}
		}
		.logoLeftAni {
			animation: logoLeftDownAmi 0.5s;
			animation-timing-function:ease-in;
			animation-fill-mode:forwards;
		}
	}
	@keyframes logoDownAmi {
		0% {
			top: 0;
			// width: 0.5rem;
			transform: translateY(-50%);
			opacity: 0;
		}
		100% {
			top: 40%;
			// width: 0.5rem;
			transform: translateY(-50%);
			opacity: 1;
		}
	}
	@keyframes logoLeftDownAmi {
		0% {
			top: -0.5rem;
			width: 2.4rem;
		}
		100% {
			// bottom: -100%;
			width: 2.4rem;
			top: 1000%;
			opacity: 0;
		}
	}
	@keyframes logoleftAmi {
		0% {
			width: 0.5rem;
			top: -0.5rem;
			
		}
		100% {
			width: 2.4rem;
			top: -0.5rem;
		}
	}
	@keyframes rightleftAmi {
		0% {
			width: 0.5rem;
			top: -0.5rem;
			
		}
		100% {
			width: 2.4rem;
			top: -0.5rem;
		}
	}
</style>
